export const CLINIC_HISTORY_SUMMARY = 1
export const EXTERNAL_CLINIC_REPORT = 2
export const LAB_TESTS_RESULTS_REPORT = 3
export const IMAGE_TESTS_RESULTS_REPORT = 4
export const X_RAYS = 5
export const SCANNER_TAC = 6
export const MAGNETIC_RESONANCE = 7
export const PET_SPECT = 8
export const OTHER_TESTS = 9
export const IMAGE = 10
export const OTHER_DOCUMENT = 11
export const RECOMMENDED_READING = 12
export const PRESCRIPTION = 13
export const TELEMEDCARE_REPORT = 14
export const DIGITAL_STETHOSCOPE_RECORDING = 15
export const SCAN_LAMP_IMAGE = 16
export const SLEEP_PLAN = 17
export const SLEEP_CERTIFICATE = 18
export const CLINICAL_ANALYSIS = 19
export const DOCUMENT_TO_COMPLETE_BY_PATIENT = 20
export const DOCUMENT_COMPLETED_BY_PATIENT = 21
export const FORM_TO_COMPLETE_BY_PATIENT = 22
export const FORM_COMPLETED_BY_PATIENT = 23
export const USEFUL_LINK = 24
export const GENETIC_TEST = 25
export const REPORT = 26
export const BILL = 27
export const RECOMMENDED_APPS = 28
export const DERMATOLOGICAL_IMAGE = 29
export const EXERCISE_RECOMMENDATIONS = 30
export const PHOTOGRAPHIC_DIETARY_RECORD = 31
export const NUTRITIONAL_RECOMMENDATIONS = 32
export const TREATMENT_INFORMATION = 33
export const GENOGRAM = 118
export const EXERCISE_PLAN = 119

export const LINK_TYPES = [USEFUL_LINK, RECOMMENDED_APPS]
export const LINK_OR_FILE = [DOCUMENT_TO_COMPLETE_BY_PATIENT, DOCUMENT_COMPLETED_BY_PATIENT, FORM_TO_COMPLETE_BY_PATIENT, FORM_COMPLETED_BY_PATIENT]

export function isDocumentOrLink(documentType) {
    return [DOCUMENT_TO_COMPLETE_BY_PATIENT, DOCUMENT_COMPLETED_BY_PATIENT, FORM_TO_COMPLETE_BY_PATIENT, FORM_COMPLETED_BY_PATIENT, USEFUL_LINK, RECOMMENDED_APPS].some(f => f === documentType)
}
export function isDocumentOrLinkPendingComplete(documentType) {
    return [DOCUMENT_TO_COMPLETE_BY_PATIENT, FORM_TO_COMPLETE_BY_PATIENT].some(f => f === documentType)
}
export function isDocumentOrLinkCompleted(documentType) {
    return [DOCUMENT_COMPLETED_BY_PATIENT, FORM_COMPLETED_BY_PATIENT].some(f => f === documentType)
}


// WEBPACK FOOTER //
// ./src/constants/db/fileCategories.js